// extracted by mini-css-extract-plugin
export default {"wrapper":"AreYouSure_wrapper__pl01l","title":"AreYouSure_title__Lt0HA","description":"AreYouSure_description__oRCIb","shine":"AreYouSure_shine__qgc0-"};